module.exports = global["moment"] = require("-!./moment.js");


//////////////////
// WEBPACK FOOTER
// ../~/moment/moment.js
// module id = 3
// module chunks = 0